







































































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { Component } from 'vue-property-decorator';
import { MswAppTitle } from '@/shared/msw-app-title';
import { SwTable, TableColumnConfig, TableEntry, ColumnSortRequestData, SortedColumnInfo, TableEntrySelectingEventData, ColumnsAdjustRequestData } from '@libs-uuif/shared/sw-table';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwExpandableTextfield, SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { InfoState } from '@/core';
import AddClaimsDialog from './add-claims-dialog.vue';
import { PageTitleConfig } from '../../../shared/msw-app-title/type';
const cssPrefix = 'mswPartnerResources';

@Component({
  components: {
    ...UUIFComponents,
    MswAppTitle,
    SwTable,
    SwDropMenu,
    SwIconButton,
    SwIcon,
    SwExpandableTextfield,
    SwTextfield,
    AddClaimsDialog,
  },
})

export default class MswPartnerResources extends SwExtendedVue {
  cssPrefix = cssPrefix;
  addClaimsDialog: boolean = false; // For add claims modal
  menuOpened: boolean = false;
  textExpanded: boolean = false;
  sortedColumns: SortedColumnInfo[] = [];
  selectedTableRows:any[] = [];
  tableData: TableEntry[] = []; // For table data
  tempTableData: TableEntry[] = []; // For duplicate table data
  partnerRescourceColConfig: TableColumnConfig[] = this.tableColConfigArr(); // Table Column Configuration
  tableLoader: boolean = false;

  filterSearch: string = '';
  searchInputChips: any[] = [];
  filterSearchConfig: any = {
    isEnableFilterSearch: false,
    filterSearchKey:'',
    filterSearchOption:'',
    filterSearchLabel:'',
  };
  globalSearchConfig: any = {
    isGlobalSearch: false,
    globalSearchKey: '',
  };

  tableColConfigArr(): TableColumnConfig[] {
    return [
      {
        key: 'selection',
        type: 'selection',
      },
      {
        key: '_key',
        dataKey: '_key',
        title: '#',
        width: 60,
      },
      {
        key: 'claimStatus',
        dataKey: 'claimStatus',
        title: this.$t('common.status')
        .toString(),
        sorter: true,
        width: 150,
      },
      {
        key: 'serialNumber',
        dataKey: 'serialNumber',
        title: this.$t('products.serialnumber')
        .toString(),
        sorter: true,
        width: 200,
      },
      {
        key: 'friendlyName',
        dataKey: 'friendlyName',
        title: this.$t('products.friendlyName')
        .toString(),
        sorter: true,
      },
      {
        key: 'custOrgName',
        dataKey: 'custOrgName',
        title: this.$t('signup.compInfo')
        .toString(),
        sorter: true,
      },
      {
        key: 'resolutionName',
        dataKey: 'resolutionName',
        title: this.$t('common.resolution')
        .toString(),
        sorter: true,
      },
      {
        key: 'comments',
        dataKey: 'comments',
        title: this.$t('common.comments')
        .toString(),
      },
    ];
  }
  // For Filter menu items
  get filterItems(): DropMenuItem[] {
    return [
      {
        id: 'claimStatus',
        content: this.$t('common.status')
        .toString(),
      },
      {
        id: 'serialNumber',
        content: this.$t('products.serialnumber')
        .toString(),
      },
      {
        id: 'friendlyName',
        content: this.$t('products.friendlyName')
        .toString(),
      },
      {
        id: 'custOrgName',
        content: this.$t('signup.compInfo')
        .toString(),
      },
      {
        id: 'resolutionName',
        content: this.$t('common.resolution')
        .toString(),
      },
    ];
  }

  // column adjust
  adjustedColumns: ColumnsAdjustRequestData = {};
  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  // Getting claims Data and formating starts
  partnerResources(partnerData:any[]) : TableEntry[] {
    const data: TableEntry[] = [];
    partnerData.forEach((entry) => {
      const newEntry: TableEntry = Object.assign({}, entry);
      if (entry.claimStatus === 'Accepted') {
        newEntry._selectable = false;
      }
      data.push(newEntry);
    });
    return data;
  }
  async getPartnerResourcesData() {
    this.selectedTableRows = [];
    this.tableLoader = true;
    await this.$store.dispatch('MswPartnerResourcesModule/getClaims')
      .then((resp: any) => {
        if (resp.msgCode === 'MSWAPP:CLAIMSSUCCESS') {
          this.tableData = this.partnerResources(resp.content.claimsList);
          this.tempTableData = this.tableData;
          // console.warn('tabledata', this.tableData);
          this.tableData.forEach((item: any, index: number) => {
            item['_key'] = index + 1;
          });
        // console.warn(this.paginationConfig.pageNumber);
        } else {
          this.showMessage('failed', resp.msgDesc || this.$t('systemMessages.oprUnSuccss')
          .toString());
        }
      })
      .catch((errResponse:any) => {
        console.error(errResponse);
        this.showMessage(
          'failed',
          this.$t('systemMessages.wrong')
          .toString(),
        );
      })
      .finally(() => {
        this.tableLoader = false;
      });
  }
  // Getting claims Data and formating ends

  // For title of the page
  get getHeaderConfig(): PageTitleConfig {
    return {
      pageTitle: this.$t('browserTitles.partnerResources')
      .toString(),
      pageParentName: this.$t('browserTitles.resourcesAndSupport')
      .toString(),
    };
  }

  // Filter Implementation starts
  handleSearchFilter() {
    if (this.globalSearchConfig.globalSearchKey !== '') {
      this.searchInputChips.push(this.globalSearchConfig.globalSearchKey.trim());
      this.applyAllFilters();
      this.globalSearchConfig.isGlobalSearch = true;
    }
    this.textExpanded = !this.textExpanded;
  }
  removeInputChip(index: any) {
    this.searchInputChips.splice(index, 1);
    this.applyAllFilters();
  }

  addFilterKey(event: any) {
    if (event.code === 'Enter' && this.filterSearchConfig.filterSearchKey !== '') {
      this.searchInputChips.push(this.filterSearchConfig.filterSearchKey.trim());
      this.applyAllFilters(this.filterSearchConfig.filterSearchOption);
      this.filterSearchConfig.filterSearchKey = '';
      this.filterSearchConfig.filterSearchLabel = '';
      this.filterSearchConfig.isEnableFilterSearch = false;
    }
  }
  applyAllFilters(option : any = 'all') {
    const data: any[] = [...this.tempTableData];
    const filteredData : any[] = [];
    this.$store.commit('startLoading');
    if (this.searchInputChips.length === 0) {
      this.tableData = [...data];
      this.$store.commit('stopLoading');
      return;
    }
    if (option === 'all') {
      this.searchInputChips.forEach((searchKey: string) => {
        filteredData.push(...data.filter((element: any) => {
          console.warn(element);
          // console.warn(element.name.indexOf(searchKey) > -1);
          // tslint:disable:newline-per-chained-call
          return (element.claimStatus.toLowerCase().indexOf(searchKey.toLowerCase()) > -1 ||
                 element.serialNumber.toLowerCase().indexOf(searchKey.toLowerCase()) > -1 ||
                 element.friendlyName.toLowerCase().indexOf(searchKey.toLowerCase()) > -1 ||
                 element.custOrgName.toLowerCase().indexOf(searchKey.toLowerCase()) > -1 ||
                 element.resolutionName.toLowerCase().indexOf(searchKey.toLowerCase()) > -1);
        }));
      });
      filteredData.forEach((ele:any, index: any) => {
        ele['_key'] = index + 1;
      });
    } else {
      this.searchInputChips.forEach((searchKey: string) => {
        filteredData.push(...data.filter((element: any) => {
          return element[option].indexOf(searchKey) > -1;
        }));
      });
      filteredData.forEach((ele:any, index: any) => {
        ele['_key'] = index + 1;
      });
    }
    this.tableData = [...filteredData];
    console.warn(this.tableData);
    this.$store.commit('stopLoading');
  }

  onRemoveAllFilters() {
    this.globalSearchConfig = {
      isGlobalSearch: false,
      globalSearchKey: '',
    };
    this.filterSearchConfig = {
      isEnableFilterSearch: false,
      filterSearchKey:'',
      filterSearchOption:'',
      filterSearchLabel:'',
    };
    this.searchInputChips = [];
    this.applyAllFilters();
  }

  onSelectMultiItem(option: any) {
    this.menuOpened = !this.menuOpened;
    this.filterSearchConfig.isEnableFilterSearch = true;
    this.filterSearchConfig.filterSearchOption = option;
    this.filterSearchConfig.filterSearchLabel = this.filterItems.filter(ele => ele.id.toString() === option)[0].content;
    setTimeout(() => {
      const filterInput = document.getElementById('filtersearch') as HTMLElement;
      // console.warn(filterInput);
      if (filterInput) {
        filterInput.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
    },         200);
  }
  // Filter Implementation ends

  // For ting the rows
  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  // On selection of table rows
  onEntrySelecting(data: TableEntrySelectingEventData) {
    const selectedKey: any = data.entryKey;
    console.warn(selectedKey);
    if (data.selecting) {
      this.selectedTableRows.push((this.tableData[Number(selectedKey) - 1]));
    } else {
      const arrIndexes = this.selectedTableRows.map((user) => { return user._key; });
      const removeIndex = arrIndexes.indexOf(Number(selectedKey));
      this.selectedTableRows.splice(removeIndex, 1);
    }
    console.warn(this.selectedTableRows);
  }

  redirectingToRenewalProductCSV() {
    this.$router.push({ path: '/m/feature/claimsreport' });
  }

  redirectingToRenewalProductReport() {
    this.$router.push({ path: '/m/feature/subscrreport?repName=CAP' });
  }

  // Opening the add claims dialog
  addClaims() {
    this.addClaimsDialog = true;
  }

  // For claiming the records not having status N/A
  async unClaim() {
    const serialNumbers:any = [];
    this.selectedTableRows.map((item:any) => serialNumbers.push({ serialNumber: item.serialNumber }));
    await this.$store.dispatch('MswPartnerResourcesModule/unClaim', serialNumbers)
      .then(async (response:any) => {
        if (response.operationStatus === 'OK' && response.msgCode === 'MSWAPP:UNCLAIMSUCCESS') {
          await this.getPartnerResourcesData();
          this.selectedTableRows = [];
          this.showMessage('success', response.msgDesc);
        } else {
          this.showMessage('failed', response.msgDesc || 'Something went wrong');
        }
      })
      .catch((errResponse:any) => {
        this.showMessage('failed', errResponse.msgDesc || 'Operation is unsuccesful');
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  async closeAddClaimsDialog(event:any) {
    this.addClaimsDialog = false;
    if (event) {
      await this.getPartnerResourcesData();
    }
  }

  created() {
    this.getPartnerResourcesData();
  }

  // For toaster message
  showMessage(infoType: string, infoMsg: string): void {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }

}
